module.exports = __webpack_public_path__ + "static/media/tshirt.5114b4e6.png";